import { queryClient } from '@/config/queryClient';
import { hasActiveReloadGuard } from '@/store/reload-guard.store';
import { hasOpenDialog } from '@/utils/open-dialogs';

/**
 * True when the user is NOT in the middle of something a reload would disrupt.
 *
 * "Mid-task" is any of:
 *  - a form registered an unsaved-changes guard (see `useUnsavedReloadGuard`),
 *  - a create/update/delete mutation is in flight (TanStack Query),
 *  - a modal/dialog is OPEN — the user is in a focused flow. "Open" is not the
 *    same as "present": the shell's mobile sidebar is a permanently mounted
 *    `role="dialog"`, so a bare query matched on every page and this function
 *    could never return true. See `open-dialogs.ts`.
 *
 * This is the safety half of the auto-update decision; the controller combines
 * it with "tab hidden or idle".
 */
export function isNotMidTask(): boolean {
  if (hasActiveReloadGuard()) return false;
  if (queryClient.isMutating() > 0) return false;
  if (hasOpenDialog()) return false;
  return true;
}
